import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TwistoAvailability } from '../../models/twisto-availability.enum';

@Component({
standalone: false,
  selector: 'app-twisto-unavailable-dialog',
  styleUrls: ['./twisto-unavailable-dialog.component.scss'],
  templateUrl: './twisto-unavailable-dialog.component.html',
})
export class TwistoUnavailableDialogComponent {
  public methodUnavailabilityReason: string;

  public twistoUnavailabilityDialog = {
    CUSTOMER_BLOCKED: {
      header: 'Twoje konto zostało zablokowane',
      content: [
        'Płatność Twisto jest niedostępna, ponieważ twoje konto zostało zablokowane.',
        'Aby odblokować konto, dokonaj weryfikacji',
      ],
      redirect: 'settings',
    },
    CREDIT_CARD_NOT_ENABLED: {
      header: 'Płatność kartą jest niedostępna',
      content: [
        'Płatność Twisto jest niedostępna, ponieważ ta faktura nie może zostać opłacona kartą.',
        'Wybierz inną fakturę',
      ],
      redirect: 'liabilities/all',
    },
    NO_PHONE_NUMBER: {
      header: 'Brak numeru telefonu',
      content: [
        'Płatność Twisto wymaga weryfikacji numerem telefonu.',
        'Aby zweryfikować konto numerem telefonu, przejdź',
      ],
      redirect: 'settings',
    },
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: IData) {}
}

interface IData {
  unverifiedBillers: string;
  twistoAvailability: TwistoAvailability;
}
